import React, { useState } from "react";

const sampleClients = [
    { name: "GS Battery", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/gs_battery.jpg?updatedAt=1759295406843" },
    { name: "CRP Group", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/crp_group.png?updatedAt=1759295406585" },
    { name: "HamiltonJet", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/HamiltonJet.jpg?updatedAt=1759295406583" },
    { name: "Chiyaboon", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/chaiyaboon.png?updatedAt=1759295406531" },
    { name: "L&T Defence", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/L%20&%20T%20Defence.jpg?updatedAt=1759295406509" },
    { name: "Vandewiele Savio", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/vandewiele_savio.jpg?updatedAt=1759295405536" },
    { name: "Dreem", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/dreem.jpg?updatedAt=1759295405197" },
  
    { name: "CMR", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/CMR.jpg?updatedAt=1759295406841" },
    { name: "SANDEN", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/sanden.png?updatedAt=1759295406829" },
    { name: "SANOH", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/sanoh.png?updatedAt=1759295406876" },
    { name: "AWAL GULF", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/awal_gulf.jpg?updatedAt=1759295406865" },
   
 ];

function ClientLogo({ client }) {
  const [imageError, setImageError] = useState(false);

  return (
    <li
      className="flex h-28 w-40 shrink-0 items-center justify-center rounded-xl border p-5 sm:h-32 sm:w-48 sm:p-6"
      style={{ backgroundColor: "#FFFFFF", borderColor: "#E5E7EB" }}
    >
      {imageError ? (
        <span
          className="text-center text-sm font-semibold"
          style={{ color: "#1E293B" }}
        >
          {client.name}
        </span>
      ) : (
        <img
          src={client.logo}
          alt={`${client.name} logo`}
          loading="eager"
          decoding="async"
          className="max-h-16 w-full object-contain"
          onError={() => setImageError(true)}
        />
      )}
    </li>
  );
}

export default function Clients() {

  return (
    <section
      className="px-4 py-14 sm:px-6 sm:py-16 lg:px-8 lg:py-20"
      style={{ backgroundColor: "#F8FAFC" }}
      aria-label="Our clients"
    >
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto mb-8 max-w-2xl text-center sm:mb-12">
          <span
            className="inline-block rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest"
            style={{ backgroundColor: "#FFF0E5", color: "#9A4512" }}
          >
            Our clients
          </span>
        </div>

        <div className="group overflow-hidden">
          <div
            className="flex w-max motion-safe:animate-marquee group-hover:[animation-play-state:paused] motion-reduce:w-full"
          >
            {[0, 1].map((copy) => (
              <ul
                key={copy}
                aria-label={copy === 0 ? "Client logos" : undefined}
                aria-hidden={copy === 1 ? true : undefined}
                className={`m-0 flex shrink-0 list-none gap-4 py-1 pl-0 pr-4 sm:gap-6 sm:pr-6 ${copy === 1 ? 'motion-reduce:hidden' : 'motion-reduce:w-full motion-reduce:flex-wrap motion-reduce:justify-center motion-reduce:pr-0'}`}
              >
                {sampleClients.map((client) => (
                  <ClientLogo key={client.name} client={client} />
                ))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
